import React from "react";
import NumberToPersianWord from "number_to_persian_word";

function getPriceBasket(price = 0, lang, postFix, isTabletOrMobile) {
 const number =
   lang === "fa"
     ? NumberToPersianWord.convertEnToPe(
         `${(price / 10).toLocaleString()}`
       )
     : (price / 10).toLocaleString("en-US");

 const suffix = isTabletOrMobile
   ? lang === "fa"
     ? postFix
     : "T"
   : postFix;

 return (
   <>
     <span>{number}</span>{" "}
     <span className={lang === "fa" ? "price_toman_fa" : ""}>
       {suffix}
     </span>
   </>
 );
}

export default getPriceBasket;